<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M51.68 8.57a2 2 0 00-1.76-2.21L38 5a2 2 0 00-1.43-.29L24 7a2 2 0 00-1.63 1.89 2.08 2.08 0 00-.76.26l-11.02 6.46a2 2 0 00-.73 2.72L32.61 58.1a2 2 0 001.22.94 2.31 2.31 0 00.52.06 2 2 0 001-.27l11.06-6.44a2 2 0 00.73-2.72l-.06-.1zm-15.52-.73l6 33.05L26.14 13l-.57-3.17zm-1.45 47.89L13 17.7l9.33-5.43L44 50.3zm10.37-15.28L39.26 8.16l9.33 1.06z"/><circle cx="35.06" cy="45.61" r="2"/></svg>